import { useQuery } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { queryClient } from "./api";
import { authClient, type Session } from "./auth-client";

export const sessionQuery = {
  queryKey: ["session"],
  queryFn: async (): Promise<Session | null> => {
    const { data } = await authClient.getSession();
    return data ?? null;
  },
  staleTime: 60_000,
};

export function fetchSession() {
  return queryClient.fetchQuery(sessionQuery);
}

export function useSession() {
  return useQuery(sessionQuery);
}

/** Route guard: redirects to the sign-in page and comes back afterwards. */
export async function requireSession(href: string): Promise<Session> {
  const session = await fetchSession();
  if (!session) throw redirect({ to: "/sign-in", search: { redirect: href } });
  return session;
}

export async function signOut() {
  await authClient.signOut();
  queryClient.clear();
  window.location.href = "/sign-in";
}

const LAST_ORG_KEY = "cva:last-org";
export const rememberOrg = (orgId: string) => localStorage.setItem(LAST_ORG_KEY, orgId);
export const lastOrg = () => localStorage.getItem(LAST_ORG_KEY);
